import { render } from "./ShareLinks.vue?vue&type=template&id=21533511&scoped=true"
import script from "./ShareLinks.vue?vue&type=script&lang=js"
export * from "./ShareLinks.vue?vue&type=script&lang=js"

import "./ShareLinks.vue?vue&type=style&index=0&id=21533511&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21533511"]])

export default __exports__